<div
  *ngIf="actions.length > 1; else elseMobileBlock"
  dropdown
  placement="top left"
  class="add-new-container d-block d-lg-none"
  container="body"
>
  <button dropdownToggle class="add-new" type="button" container="body">
    <div class="border-block">
      <span class="icon-ic_plus"></span>
    </div>
  </button>
  <div *dropdownMenu class="dropdown-menu dropdown-menu-right custom custom-default">
    <button *ngFor="let action of actions" class="dropdown-item" [routerLink]="action.routerLink">{{ action.title | translate }}</button>
  </div>
</div>
<ng-template #elseMobileBlock>
  <div class="add-new-container d-block d-lg-none" *ngIf="actions.length === 1">
    <button class="add-new" [routerLink]="actions[0].routerLink" type="button">
      <div class="border-block">
        <span class="icon-ic_plus"></span>
      </div>
    </button>
  </div>
</ng-template>
